import { memo } from 'react';

import { Download } from '@air/next-icons';
import { Button, type ButtonProps } from '@air/primitive-button';

export type DownloadButtonProps = Pick<Required<ButtonProps>, 'onClick'> & {
  hasMultiple: boolean;
};

export const DownloadButton = memo(({ hasMultiple, onClick }: DownloadButtonProps) => (
  <Button
    appearance="filled"
    color="grey"
    data-testid="SELECTION_ACTION_BAR_DOWNLOAD"
    onClick={onClick}
    prefix={<Download className="size-4 ui2:size-3" />}
    size="small"
    className="ui2:rounded-4"
  >
    {hasMultiple ? 'Download all' : 'Download'}
  </Button>
));

DownloadButton.displayName = 'DownloadButton';
